import Button from 'components/common/Button';
import useMartyContext from 'hooks/useMartyContext';

interface SubmitReturnProps {
  onCancelReturn: () => void;
  onSubmitReturn: () => void;
  isSubmitDisabled: boolean;
  cancelButtonText: string;
}

const SubmitReturn = ({ onCancelReturn, onSubmitReturn, isSubmitDisabled, cancelButtonText = 'Cancel' }: SubmitReturnProps) => {
  const { testId } = useMartyContext();

  return (
    <span className="my-8 flex flex-wrap items-center gap-2">
      <Button height="small" variant="outlined" onClick={onCancelReturn} data-test-id={testId('cancelButton')}>
        {cancelButtonText}
      </Button>
      <Button height="small" variant="filled" onClick={onSubmitReturn} disabled={isSubmitDisabled} data-test-id={testId('submitReturn')}>
        Submit Return
      </Button>
    </span>
  );
};

export default SubmitReturn;
